// composables/useCompanyFormData.ts
import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useSalaryEmployeeData(companyId?: number) {
    const { data: employeesOptions, isPending: isPendingEmployeesOptions } = useQuery({
        queryKey: [QueryKey.SALARY_EMPLOYEES, companyId],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.salary.employees.get', companyId));
            return data;
        },
        placeholderData: [],
    });

    return {
        employeesOptions,
        isPendingEmployeesOptions,
    };
}
